import { render, staticRenderFns } from "./ListaView.vue?vue&type=template&id=3cf2110b&"
import script from "./lista.js?vue&type=script&lang=js&"
export * from "./lista.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports